import { render, staticRenderFns } from "./SuperAdminCustodyOperators.vue?vue&type=template&id=5f8d2d1c&scoped=true&lang=pug"
import script from "./SuperAdminCustodyOperators.vue?vue&type=script&lang=ts"
export * from "./SuperAdminCustodyOperators.vue?vue&type=script&lang=ts"
import style0 from "./SuperAdminCustodyOperators.vue?vue&type=style&index=0&id=5f8d2d1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8d2d1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VForm,VIcon,VSelect,VTextField})
